import { render, staticRenderFns } from "./CopyHandler.vue?vue&type=template&id=004d0e83&"
import script from "./CopyHandler.vue?vue&type=script&lang=js&"
export * from "./CopyHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports